export default function generateUniqueId() {
    const timestamp = new Date().getTime();

    // Generate a random number between 0 and 999999 (you can adjust the range as needed)
    const randomNum = Math.floor(Math.random() * 10000);

    // Combine the timestamp and random number to create the unique ID
    return `${timestamp}${randomNum}`;

}